import { render, staticRenderFns } from "./finishForm.vue?vue&type=template&id=230d92c4&"
import script from "./finishForm.vue?vue&type=script&lang=js&"
export * from "./finishForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports